import React from 'react';

import manIcon from '../../assets/images/man.svg';
import womanIcon from '../../assets/images/woman.svg';

interface GenderProps {
  gender: 'M' | 'W' | 'F';
}

const Gender: React.FC<GenderProps> = ({ gender }) => {
  return (
    <div
      className={`w-6 group-hover:w-8 ease-in-out transition-all flex items-center justify-center rounded-full h-6 ${gender === 'M' ? 'bg-blue-100' : 'bg-pink-100'}`}
    >
      <img className="w-3" src={gender === 'M' ? manIcon : womanIcon} alt="" />
    </div>
  );
};

export default Gender;
